module.exports = __webpack_public_path__ + "static/media/14.e0aece99.jpg";